import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { forwardRef, type PropsWithChildren, type ReactElement } from 'react'
import {
  headingIcon,
  title,
  titleActions,
  titleContainer
} from './PaperTitle.css'

type PaperTitleProps = PropsWithChildren<{
  className?: string
  titleClassName?: string
  contentPadding?: boolean
  icon?: IconProp
  actions?: ReactElement
}>

export const PaperTitle = forwardRef<HTMLHeadingElement, PaperTitleProps>(
  ({ children, className, titleClassName, icon, actions }, ref) => {
    return (
      <div className={clsx(titleContainer, className)}>
        <h2 ref={ref} className={clsx(title, titleClassName)}>
          {icon && <FontAwesomeIcon className={headingIcon} icon={icon} />}
          {children}
        </h2>
        {actions && <div className={titleActions}>{actions}</div>}
      </div>
    )
  }
)
